import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router';

export default function useDiagnosisService() {
  const queryClient = useQueryClient();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();


  const addAction = useMutation({
    mutationFn: async (code: string) => {
      await axios.post(
        `/api/camel/patient_profile/clinical_info/${patientUuid}/icd/${code}`
      );
      invalidateClinicalQuery();
      if (patientUuid) await invalidatePatientQuery(patientUuid);
    },
  });

  const deleteAction = useMutation({
    mutationFn: async (code: string) => {
      await axios.delete(
        `/api/camel/patient_profile/clinical_info/${patientUuid}/icd/${code}`
      );
      invalidateClinicalQuery();
      if (patientUuid) await invalidatePatientQuery(patientUuid);
    },
  });

  const invalidateClinicalQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patient_profile', 'clinical_info', patientUuid],
    });
  };
  
  const invalidatePatientQuery = async (patientUuid: string) => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patients', patientUuid],
    });
  };

  return {
    isLoading: false,
    addDiagnosis: addAction.mutateAsync,
    deleteDiagnosis: deleteAction.mutateAsync,
  };
}
